<template lang="html">
    <div class="main-container">

        <ul class="breadcrumb">
            <li>
                <a href="#">Organisation</a>
            </li>
            <li>
                <a href="#">Utilities</a>
            </li>
            <li>
                <a href="#">Loan List</a>
            </li>
            <li>
                <a href="#">Loan</a>
            </li>
            <li>Import</li>
        </ul>
        <tl-header type="h1">
            <div class="main-header">Import Employee Loan Details</div>
        </tl-header>

        <div class="download-btn">
            <download-button></download-button>
        </div>

        <div class="upload">
            <p></p>
            <p>Drag & drop files here</p>
            <p>Or</p>
            <div class="upload-button">
                <img src="@/assets/logout-copy-2_2@2x.png" alt>
                <label for="upload-photo">Browse</label>
                <input type="file" name="photo" id="upload-photo">
            </div>
        </div>

        <div class="btn-group">
            <btn text="Import" type="primary" @click="importEmployeeLoanDetails" />
        </div>

        <div class="btn-group">
            <bottom-action-container>
                <btn-grp slot="end">
                    <btn text="Close" type="secondary" @click="close" />
                </btn-grp>
            </bottom-action-container>
        </div>


    </div>
</template>

<script>
    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex';

    export default {
        name: 'importEmployeeLoanDetails',
        computed: {
            ...mapState({
            }),
            ...mapGetters({
                orgid: "onboard/organization/orgid"
            }),
        },
        data() {
            return {
            }
        },
        mounted() {

        },

        methods: {
            ...mapActions({
            }),

            importEmployeeLoanDetails() {

            },

            close() {
                this.$router.push({
                    path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loans`
                })
            },
        }


    }

</script>

<style lang="scss" scoped>
    .upload {
        display: flex;
        width: 30%;
        margin-top: 2%;
        flex-direction: column;
        align-items: center;
        background: linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%), linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%), linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%), linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
        background-position: top, right, bottom, left;
        background-repeat: repeat-x, repeat-y;
        background-size: 20px 1px, 1px 20px;
        height: 140px;
    }

    .upload-button {
        display: flex;
        align-items: center;
        label {
            cursor: pointer;
            border: 1px solid #5d409f;
            border-radius: 4px;
            padding: 6px 12px;
            font-size: 15px;
            color: #5d409f;
        }
        #upload-photo {
            opacity: 0;
            position: absolute;
            z-index: -1;
        }
        img {
            height: 19px;
            width: 19px;
            margin-right: 8px;
        }
    }

    .download-btn {
        margin-top: 2%;
    }
</style>